import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

// components
import GroupMembersLink from 'src/components/group_members_link/group_members_link'
import MessageBoxModal from 'src/components/message_box/message_box_with_modal'

// constants & interfaces
import {
  MSGBOX_BUTTON_TYPE_CANCEL,
  MSGBOX_BUTTON_TYPE_PRIMARY
} from 'src/components/message_box/message_box'
import { CLASS_PREFIX } from 'src/constants/'
import { FRONTEND_GROUP_OVERVIEW_PATH } from 'src/constants/urls'

// helpers
import { textResources } from 'src/lang/de'

import './group_info.scss'
import { GroupDetailFragmentFragment } from '@lopo-tech/lopo-api'
import {
  useGroupJoinConfirmation
} from 'src/containers/smart_components/group_member_list/hooks/useGroupJoinConfirmation'

const cls = `${CLASS_PREFIX}group-info`
const labels = textResources.groups

interface IProps {
  group: GroupDetailFragmentFragment;
  intermediateOrNotLoggedIn: boolean;
}

const GroupInfo: React.FC<IProps> = ({ group, intermediateOrNotLoggedIn }) => {
  const [messageBoxShown, setMessageBoxShown] = useState(false)
  const history = useHistory()
  const { onGroupJoin } = useGroupJoinConfirmation()

  const showMessageBox = () => {
    setMessageBoxShown(true)
  }

  const hideMessageBox = () => {
    setMessageBoxShown(false)
  }

  const getOptions = () => {
    if (group.canJoin) {
      return {
        info: labels.ctaNotJoinedMembers.infoCanJoin_WEB,
        mainButton: {
          label: labels.joinGroup,
          onClick: () => {
            onGroupJoin(group)
            hideMessageBox()
          }
        }
      }
    }
    return {
      info: labels.ctaNotJoinedMembers.infoCanNotJoin,
      mainButton: {
        label: labels.groupsInMyRegion,
        onClick: () => {
          history.push(FRONTEND_GROUP_OVERVIEW_PATH)
        }
      }
    }
  }

  const options = getOptions()

  const isPending = Boolean(
    group.ownGroupParticipation && !group.ownGroupParticipation.confirmedAt
  )

  return (
    <div className={cls} >
      {messageBoxShown &&
        <MessageBoxModal
          title={isPending ? labels.pending : labels.ctaNotJoinedMembers.title_WEB(group.name)}
          onClose={hideMessageBox}
          buttons={
            isPending
              ? [
                {
                  label: textResources.shared.cancel,
                  onClick: hideMessageBox,
                  type: MSGBOX_BUTTON_TYPE_CANCEL
                }
              ]
              : [
                {
                  label: options.mainButton.label,
                  onClick: options.mainButton.onClick,
                  type: MSGBOX_BUTTON_TYPE_PRIMARY
                },
                {
                  label: textResources.shared.cancel,
                  onClick: hideMessageBox,
                  type: MSGBOX_BUTTON_TYPE_CANCEL
                }
              ]
          }
        >
          {options.info}
        </MessageBoxModal>}
      <h3 className={cls + '__title'}>{group.name}</h3>
      <p className={cls + '__member-count'}>{labels.memberCount(group.confirmedMembersCount || 0)}</p>
      <p className={cls + '__description'}>{group.description}</p>
      <GroupMembersLink
        onNoReadPermissions={showMessageBox}
        intermediateOrNotLoggedIn={intermediateOrNotLoggedIn}
        canRead={group.canShowGroupParticipations?.value ?? false}
        groupIdentifier={group.slug}
      />
    </div>)
}

export default GroupInfo
